import { accentVar, isAccent } from "@codeshare/theme";

/** "Swift Otter" → "SO". */
export const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");

/** A colored circle with someone's initials (generated content: not part of accessible names). */
export function Avatar({
  name,
  color,
  size = "md",
}: {
  name: string;
  color?: string;
  size?: "sm" | "md";
}) {
  return (
    <span
      className={`avatar avatar-${size}`}
      data-initials={initials(name)}
      style={color && isAccent(color) ? { background: accentVar(color) } : undefined}
    />
  );
}
